import styled from 'styled-components';
import { getThemeProps } from 'ravenjs/utils/theme';

const SubNavigationStyled = styled.div`
    align-items: center;
    background-color: ${getThemeProps('palette.common.white')};
    border-bottom: 1px solid ${getThemeProps('palette.common.lighter')};
    box-shadow: ${getThemeProps('shadows.bottom[5]')};
    color: ${getThemeProps('palette.common.dark')};
    display: flex;
    height: ${getThemeProps('AppNavigation.height')}px;
    justify-content: space-between;
    left: 0;
    opacity: 1;
    overflow: hidden;
    padding: 0 15px 0 0;
    position: fixed;
    right: 0;
    top: ${getThemeProps('AppNavigation.height')}px;
    transition: opacity 0.25s ease-in-out, top 0.3s ease-in-out;
    z-index: 9;
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('SubNavigation.styles')};
    /**
     * Add in dynamic styles
     */
    ${({ show }) =>
        !show && {
            opacity: 0,
            top: 0,
            transition: 'opacity 0.5s ease-in-out, top 0.3s ease-in-out',
        }};
`;

export default SubNavigationStyled;
